import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  Grid,
  TextField,
} from '@material-ui/core';
import React, { useContext } from 'react';
import { OPCIONES_APLICA_A, TablaSeleccionablesContext } from './tablaSeleccionables';

export default function DialogoCRUDRegistroSeleccionable() {
  const {
    openDialogoCRUD,
    setOpenDialogoCRUD,
    tituloDialogo,
    nombre,
    setNombre,
    handleAceptar,
    disableEditing,
    id,
    conAplicaA,
    aplicaA,
    setAplicaA,
  } = useContext(TablaSeleccionablesContext);

  const handleClose = () => setOpenDialogoCRUD(false);

  const handleChangeAplicaA = (value, checked) =>
    setAplicaA(checked ? [...aplicaA, value] : aplicaA.filter((a) => a !== value));

  const sinAplicaA = conAplicaA && aplicaA.length === 0;

  return (
    <Dialog open={openDialogoCRUD} maxWidth="md" fullWidth>
      <DialogTitle>{tituloDialogo}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              label="Nombre"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              variant="outlined"
              fullWidth
              disabled={disableEditing}
            />
          </Grid>
          {conAplicaA && (
            <Grid item xs={6}>
              <FormControl error={sinAplicaA} disabled={disableEditing}>
                <FormLabel>Aplica a</FormLabel>
                <FormGroup row>
                  {OPCIONES_APLICA_A.map((opcion) => (
                    <FormControlLabel
                      key={opcion.value}
                      label={opcion.label}
                      control={
                        <Checkbox
                          checked={aplicaA.includes(opcion.value)}
                          onChange={(e) => handleChangeAplicaA(opcion.value, e.target.checked)}
                        />
                      }
                    />
                  ))}
                </FormGroup>
                {sinAplicaA && <FormHelperText>Seleccione al menos una opción.</FormHelperText>}
              </FormControl>
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="outlined" color="primary">
          Cancelar
        </Button>
        <Button
          onClick={() => handleAceptar(tituloDialogo, nombre, id)}
          disabled={sinAplicaA}
          variant="contained"
          color="primary"
        >
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
